import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToHourMinuteConversion',
  pure: true
})
export class NumberToHourMinuteConversionPipe implements PipeTransform {

  transform(time: number, title: string): string {
    if (!time) {
      return `${title}: 00:00`;
    }
    else {
      const hour = Math.floor(time);
      const minute = Math.round((time - hour) * 100);
      const hourString = hour < 10 ? '0' + hour : hour;
      const minuteString = minute < 10 ? '0' + minute : minute;

      return Number.isInteger(Number(hourString)) && Number.isInteger(Number(minuteString)) ? `${title}: ${hourString}:${minuteString}` : `${title}: 00:00`;
    }
  }

}